window.addEventListener("load", function(){

  function initFiler(el) {
    let box = el.getElementsByClassName('filter-drop-down')[0];
    let trigger = el.getElementsByClassName('filter-trigger')[0];
    let arrow = el.getElementsByClassName('filter-arrow')[0];
    box.style.display = 'none'

    trigger.addEventListener("click", toogleFilterTrigger);

    function toogleFilterTrigger(){
      if(box.style.display == 'none'){
        box.style.display = 'block';
        arrow.classList.add('up')
      }
      else{
        box.style.display = 'none';
        arrow.classList.remove('up')
      }
    }
  }

  for(const filter of document.getElementsByClassName('filter')) {
    initFiler(filter);
  };
});
